class ProductImageZoom {
  constructor() {
    this.init();
  }

  init() {
    this.setupZoomContainers();
    this.bindEvents();
  }

  setupZoomContainers() {
    // Handle regular product images
    const productImages = document.querySelectorAll('.product__media-item img.product-slider-image');
    productImages.forEach((img, index) => {
      const mediaItem = img.closest('.product__media-item');
      if (mediaItem && !mediaItem.classList.contains('product__media-item--full')) {
        this.createZoomContainer(img);
      }
    });

    // Handle bundle group images
    const bundleImages = document.querySelectorAll('.bundle-group__image');
    bundleImages.forEach((img, index) => {
      this.createBundleZoomContainer(img);
    });
  }

  createZoomContainer(img) {
    const container = img.closest('.product__media');
    if (!container) return;

    // Create zoom wrapper
    const zoomWrapper = document.createElement('div');
    zoomWrapper.className = 'product-image-zoom-wrapper';
    zoomWrapper.style.cssText = `
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 100%;
    `;

    // Create zoom image (high resolution)
    const zoomImage = document.createElement('img');
    zoomImage.className = 'product-image-zoom-image';
    
    // Try to get higher resolution image
    let highResSrc = img.src;
    if (img.src.includes('_')) {
      highResSrc = img.src.replace(/_\d+x\d+/, '_2048x2048');
    } else {
      const extension = img.src.split('.').pop();
      highResSrc = img.src.replace(`.${extension}`, `_2048x2048.${extension}`);
    }
    
    zoomImage.src = highResSrc;
    zoomImage.alt = img.alt;
    
    // Fallback to original image if high-res fails
    zoomImage.onerror = () => {
      zoomImage.src = img.src;
    };
    zoomImage.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: auto;
      height: auto;
      max-width: none;
      max-height: none;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
      z-index: 10;
    `;

    // Insert zoom wrapper before the original image
    img.parentNode.insertBefore(zoomWrapper, img);
    zoomWrapper.appendChild(img);
    zoomWrapper.appendChild(zoomImage);

    // Store references
    img.zoomWrapper = zoomWrapper;
    img.zoomImage = zoomImage;
  }

  createBundleZoomContainer(img) {
    const container = img.closest('.bundle-group__image__container');
    if (!container) return;

    // Create zoom wrapper
    const zoomWrapper = document.createElement('div');
    zoomWrapper.className = 'bundle-image-zoom-wrapper';
    zoomWrapper.style.cssText = `
      position: relative;
      overflow: hidden;
      width: 100%;
      height: 100%;
    `;

    // Create zoom image (high resolution)
    const zoomImage = document.createElement('img');
    zoomImage.className = 'bundle-image-zoom-image';
    
    // Try to get higher resolution image
    let highResSrc = img.src;
    if (img.src.includes('500x')) {
      highResSrc = img.src.replace('500x', '2048x2048');
    } else if (img.src.includes('_')) {
      highResSrc = img.src.replace(/_\d+x\d*/, '_2048x2048');
    } else {
      const extension = img.src.split('.').pop();
      if (extension && !highResSrc.includes('placeholder')) {
        highResSrc = img.src.replace(`.${extension}`, `_2048x2048.${extension}`);
      }
    }
    
    zoomImage.src = highResSrc;
    zoomImage.alt = img.alt;
    zoomImage.loading = 'lazy';
    
    // Fallback to original image if high-res fails
    zoomImage.onerror = () => {
      zoomImage.src = img.src;
    };
    zoomImage.style.cssText = `
      position: absolute;
      top: 0;
      left: 0;
      width: auto;
      height: auto;
      max-width: none;
      max-height: none;
      opacity: 0;
      transition: opacity 0.3s ease;
      pointer-events: none;
      z-index: 10;
    `;

    // Insert zoom wrapper before the original image
    img.parentNode.insertBefore(zoomWrapper, img);
    zoomWrapper.appendChild(img);
    zoomWrapper.appendChild(zoomImage);

    // Store references
    img.zoomWrapper = zoomWrapper;
    img.zoomImage = zoomImage;
  }

  bindEvents() {
    // Desktop hover events
    if (window.innerWidth > 768) {
      this.bindDesktopEvents();
    } else {
      this.bindMobileEvents();
    }

    // Handle window resize
    window.addEventListener('resize', () => {
      if (window.innerWidth > 768) {
        this.bindDesktopEvents();
      } else {
        this.bindMobileEvents();
      }
    });

    // Listen for bundle image changes
    this.observeBundleImageChanges();
  }

  bindDesktopEvents() {
    // Handle regular product images
    const zoomWrappers = document.querySelectorAll('.product-image-zoom-wrapper');
    zoomWrappers.forEach(wrapper => {
      const img = wrapper.querySelector('.product-slider-image');
      const zoomImage = wrapper.querySelector('.product-image-zoom-image');
      
      if (!img || !zoomImage) return;

      // Remove existing event listeners
      wrapper.removeEventListener('mouseenter', this.handleMouseEnter);
      wrapper.removeEventListener('mousemove', this.handleMouseMove);
      wrapper.removeEventListener('mouseleave', this.handleMouseLeave);

      // Add new event listeners
      wrapper.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      wrapper.addEventListener('mousemove', this.handleMouseMove.bind(this));
      wrapper.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    });

    // Handle bundle images
    const bundleZoomWrappers = document.querySelectorAll('.bundle-image-zoom-wrapper');
    bundleZoomWrappers.forEach(wrapper => {
      const img = wrapper.querySelector('.bundle-group__image');
      const zoomImage = wrapper.querySelector('.bundle-image-zoom-image');
      
      if (!img || !zoomImage) return;

      // Remove existing event listeners
      wrapper.removeEventListener('mouseenter', this.handleMouseEnter);
      wrapper.removeEventListener('mousemove', this.handleMouseMove);
      wrapper.removeEventListener('mouseleave', this.handleMouseLeave);

      // Add new event listeners
      wrapper.addEventListener('mouseenter', this.handleMouseEnter.bind(this));
      wrapper.addEventListener('mousemove', this.handleMouseMove.bind(this));
      wrapper.addEventListener('mouseleave', this.handleMouseLeave.bind(this));
    });
  }

  bindMobileEvents() {
    // Handle regular product images
    const zoomWrappers = document.querySelectorAll('.product-image-zoom-wrapper');
    zoomWrappers.forEach(wrapper => {
      const img = wrapper.querySelector('.product-slider-image');
      const zoomImage = wrapper.querySelector('.product-image-zoom-image');
      
      if (!img || !zoomImage) return;

      // Remove existing event listeners
      wrapper.removeEventListener('touchstart', this.handleTouchStart);
      wrapper.removeEventListener('touchmove', this.handleTouchMove);
      wrapper.removeEventListener('touchend', this.handleTouchEnd);

      // Add new event listeners
      wrapper.addEventListener('touchstart', this.handleTouchStart.bind(this));
      wrapper.addEventListener('touchmove', this.handleTouchMove.bind(this));
      wrapper.addEventListener('touchend', this.handleTouchEnd.bind(this));
    });

    // Handle bundle images
    const bundleZoomWrappers = document.querySelectorAll('.bundle-image-zoom-wrapper');
    bundleZoomWrappers.forEach(wrapper => {
      const img = wrapper.querySelector('.bundle-group__image');
      const zoomImage = wrapper.querySelector('.bundle-image-zoom-image');
      
      if (!img || !zoomImage) return;

      // Remove existing event listeners
      wrapper.removeEventListener('touchstart', this.handleTouchStart);
      wrapper.removeEventListener('touchmove', this.handleTouchMove);
      wrapper.removeEventListener('touchend', this.handleTouchEnd);

      // Add new event listeners
      wrapper.addEventListener('touchstart', this.handleTouchStart.bind(this));
      wrapper.addEventListener('touchmove', this.handleTouchMove.bind(this));
      wrapper.addEventListener('touchend', this.handleTouchEnd.bind(this));
    });
  }

  observeBundleImageChanges() {
    // Watch for bundle image src changes when users select different swatches
    const bundleImages = document.querySelectorAll('.bundle-group__image');
    
    bundleImages.forEach(img => {
      // Create observer for src attribute changes
      const observer = new MutationObserver((mutations) => {
        mutations.forEach(mutation => {
          if (mutation.type === 'attributes' && mutation.attributeName === 'src') {
            this.updateBundleZoomImage(img);
          }
        });
      });

      observer.observe(img, { attributes: true, attributeFilter: ['src'] });
    });

    // Also listen for swatch clicks to update zoom images
    const bundleSwatches = document.querySelectorAll('.bundle-group__swatch');
    bundleSwatches.forEach(swatch => {
      swatch.addEventListener('click', (e) => {
        setTimeout(() => {
          const imageTarget = e.target.dataset.imageTarget;
          if (imageTarget) {
            const targetImg = document.querySelector(imageTarget);
            if (targetImg) {
              this.updateBundleZoomImage(targetImg);
            }
          }
        }, 100); // Small delay to ensure image src is updated
      });
    });
  }

  updateBundleZoomImage(img) {
    const zoomImage = img.zoomImage;
    if (!zoomImage) return;

    // Update zoom image source
    let highResSrc = img.src;
    if (img.src.includes('500x')) {
      highResSrc = img.src.replace('500x', '2048x2048');
    } else if (img.src.includes('_')) {
      highResSrc = img.src.replace(/_\d+x\d*/, '_2048x2048');
    } else {
      const extension = img.src.split('.').pop();
      if (extension && !highResSrc.includes('placeholder')) {
        highResSrc = img.src.replace(`.${extension}`, `_2048x2048.${extension}`);
      }
    }

    zoomImage.src = highResSrc;
    zoomImage.onerror = () => {
      zoomImage.src = img.src;
    };
  }

  handleMouseEnter(e) {
    const wrapper = e.currentTarget;
    const zoomImage = wrapper.querySelector('.product-image-zoom-image, .bundle-image-zoom-image');
    
    if (zoomImage) {
      zoomImage.style.opacity = '1';
    }
  }

  handleMouseMove(e) {
    const wrapper = e.currentTarget;
    const img = wrapper.querySelector('.product-slider-image, .bundle-group__image');
    const zoomImage = wrapper.querySelector('.product-image-zoom-image, .bundle-image-zoom-image');
    
    if (!img || !zoomImage) return;

    const rect = wrapper.getBoundingClientRect();
    const x = e.clientX - rect.left;
    const y = e.clientY - rect.top;
    
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;
    
    // Calculate zoom image position
    const zoomRect = zoomImage.getBoundingClientRect();
    const zoomX = -(xPercent / 100) * (zoomRect.width - rect.width);
    const zoomY = -(yPercent / 100) * (zoomRect.height - rect.height);
    
    zoomImage.style.transform = `translate(${zoomX}px, ${zoomY}px)`;
  }

  handleMouseLeave(e) {
    const wrapper = e.currentTarget;
    const zoomImage = wrapper.querySelector('.product-image-zoom-image, .bundle-image-zoom-image');
    
    if (zoomImage) {
      zoomImage.style.opacity = '0';
      zoomImage.style.transform = 'translate(0, 0)';
    }
  }

  handleTouchStart(e) {
    const wrapper = e.currentTarget;
    const zoomImage = wrapper.querySelector('.product-image-zoom-image, .bundle-image-zoom-image');
    
    if (zoomImage && e.touches.length === 1) {
      const touch = e.touches[0];
      const currentTime = Date.now();
      
      // Check for double tap
      if (wrapper.lastTapTime && (currentTime - wrapper.lastTapTime) < 300) {
        // Double tap detected - toggle zoom
        if (wrapper.isZoomed) {
          // Zoom out
          zoomImage.style.opacity = '0';
          zoomImage.style.transform = 'translate(0, 0)';
          wrapper.isZoomed = false;
          wrapper.zoomActivated = false;
          wrapper.classList.remove('is-zoomed');
        } else {
          // Zoom in
          zoomImage.style.opacity = '1';
          wrapper.isZoomed = true;
          wrapper.zoomActivated = true;
          wrapper.classList.add('is-zoomed');
        }
        wrapper.lastTapTime = null;
        return;
      }
      
      // Store initial touch position and time
      wrapper.touchStartX = touch.clientX;
      wrapper.touchStartY = touch.clientY;
      wrapper.touchStartTime = currentTime;
      wrapper.touchMoved = false;
      wrapper.zoomActivated = false;
      wrapper.lastTapTime = currentTime;
    }
  }

  handleTouchMove(e) {
    if (e.touches.length !== 1) return;
    
    const wrapper = e.currentTarget;
    const img = wrapper.querySelector('.product-slider-image, .bundle-group__image');
    const zoomImage = wrapper.querySelector('.product-image-zoom-image, .bundle-image-zoom-image');
    
    if (!img || !zoomImage) return;

    const touch = e.touches[0];
    const deltaX = Math.abs(touch.clientX - wrapper.touchStartX);
    const deltaY = Math.abs(touch.clientY - wrapper.touchStartY);
    const deltaTime = Date.now() - wrapper.touchStartTime;
    
    // Mark that touch has moved
    wrapper.touchMoved = true;
    
    // If this is the first significant movement, determine if it's a swipe or zoom gesture
    if (!wrapper.zoomActivated && !wrapper.isZoomed) {
      // If horizontal movement is greater than vertical, it's likely a swipe gesture
      if (deltaX > deltaY && deltaX > 10) {
        // This is a swipe gesture, don't activate zoom
        return;
      }
      
      // If vertical movement is significant or touch duration is long, activate zoom
      if (deltaY > 15 || deltaTime > 300) {
        wrapper.zoomActivated = true;
        wrapper.isZoomed = true;
        wrapper.classList.add('is-zoomed');
        zoomImage.style.opacity = '1';
        e.preventDefault();
      } else {
        // Not enough movement to determine gesture type yet
        return;
      }
    }
    
    // Only handle zoom if zoom is activated
    if (!wrapper.zoomActivated || !wrapper.isZoomed) return;

    e.preventDefault();
    
    const rect = wrapper.getBoundingClientRect();
    const x = touch.clientX - rect.left;
    const y = touch.clientY - rect.top;
    
    const xPercent = (x / rect.width) * 100;
    const yPercent = (y / rect.height) * 100;
    
    // Calculate zoom image position
    const zoomRect = zoomImage.getBoundingClientRect();
    const zoomX = -(xPercent / 100) * (zoomRect.width - rect.width);
    const zoomY = -(yPercent / 100) * (zoomRect.height - rect.height);
    
    zoomImage.style.transform = `translate(${zoomX}px, ${zoomY}px)`;
  }

  handleTouchEnd(e) {
    const wrapper = e.currentTarget;
    const zoomImage = wrapper.querySelector('.product-image-zoom-image, .bundle-image-zoom-image');
    
    if (zoomImage) {
      // Reset zoom state
      zoomImage.style.opacity = '0';
      zoomImage.style.transform = 'translate(0, 0)';
      wrapper.isZoomed = false;
      wrapper.zoomActivated = false;
      wrapper.classList.remove('is-zoomed');
      
      // Clear touch tracking variables
      wrapper.touchStartX = null;
      wrapper.touchStartY = null;
      wrapper.touchStartTime = null;
      wrapper.touchMoved = false;
    }
  }

  // Public method to reinitialize zoom for dynamically added content
  reinitialize() {
    this.setupZoomContainers();
    this.bindEvents();
  }
}

// Initialize when DOM is ready
document.addEventListener('DOMContentLoaded', () => {
  window.productImageZoom = new ProductImageZoom();
});

// Also initialize for dynamic content (like AJAX loaded products)
document.addEventListener('shopify:section:load', () => {
  if (window.productImageZoom) {
    window.productImageZoom.reinitialize();
  } else {
    window.productImageZoom = new ProductImageZoom();
  }
});

// Initialize for bundle-specific dynamic content
document.addEventListener('bundle:updated', () => {
  if (window.productImageZoom) {
    window.productImageZoom.reinitialize();
  }
});